import { Add, Delete, Remove } from "@material-ui/icons";
import {
  Box,
  Checkbox,
  Fab,
  FormControlLabel,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { TimeField } from "@mui/x-date-pickers";
import Select from "components/select/Select";
import { LIST_DAY } from "constant";
import { FieldArray } from "formik";

import CallFlowPlanDetail from "./call-flow-plan-detail/CallFlowPlanDetail";

const CallFlowSetupPlan = ({ title, formKey, formik, mode }) => {
  const isViewMode = mode === "view";

  return (
    <Box>
      <FormControlLabel
        sx={{ whiteSpace: "nowrap" }}
        control={
          <Checkbox
            checked={formik.values[formKey]?.checked}
            onChange={(e) =>
              formik.setFieldValue(`${formKey}.checked`, e.target.checked)
            }
          />
        }
        label={title}
      />

      <Box sx={{ px: 3 }}>
        <FieldArray
          name={`${formKey}.time`}
          render={(arrayHelpers) => (
            <div>
              <Box>
                <Typography component="span" mr={2} fontWeight={500}>
                  Thời gian
                </Typography>
                {!isViewMode && (
                  <Tooltip title="Thêm khoảng thời gian">
                    <Fab
                      color="primary"
                      size="small"
                      onClick={() => {
                        const fromTimeDefault = new Date();
                        fromTimeDefault.setHours(0, 0, 0, 0);
                        const toTimeDefault = new Date();
                        toTimeDefault.setHours(23, 59, 0, 0);
                        arrayHelpers.push({
                          fromDay: 1,
                          toDay: 0,
                          fromTime: fromTimeDefault,
                          toTime: toTimeDefault,
                        });
                      }}>
                      <Add />
                    </Fab>
                  </Tooltip>
                )}
              </Box>

              {formik.values[formKey]?.time &&
                formik.values[formKey]?.time.length > 0 &&
                formik.values[formKey]?.time.map((_item, index) => (
                  <Grid container key={index} spacing={1.5} my={0.5}>
                    <Grid item xs={12} md={4}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Select
                          options={LIST_DAY}
                          value={formik.values[formKey]?.time?.[index]?.fromDay}
                          onChange={(newValue) =>
                            formik.setFieldValue(
                              `${formKey}.time.${index}.fromDay`,
                              newValue
                            )
                          }
                          showSearch={false}
                        />
                        <Remove />
                        <Select
                          options={LIST_DAY}
                          value={formik.values[formKey]?.time?.[index]?.toDay}
                          onChange={(newValue) =>
                            formik.setFieldValue(
                              `${formKey}.time.${index}.toDay`,
                              newValue
                            )
                          }
                          showSearch={false}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Stack direction="row" spacing={2} ml={5}>
                        <TimeField
                          label="Từ giờ"
                          value={
                            new Date(
                              formik.values[formKey]?.time?.[index]?.fromTime
                            )
                          }
                          onChange={(newValue) =>
                            formik.setFieldValue(
                              `${formKey}.time.${index}.fromTime`,
                              newValue
                            )
                          }
                          format="HH:mm"
                          variant="standard"
                        />
                        <TimeField
                          label="Đến giờ"
                          value={
                            new Date(
                              formik.values[formKey]?.time?.[index]?.toTime
                            )
                          }
                          onChange={(newValue) =>
                            formik.setFieldValue(
                              `${formKey}.time.${index}.toTime`,
                              newValue
                            )
                          }
                          format="HH:mm"
                          variant="standard"
                        />
                      </Stack>
                    </Grid>

                    {!isViewMode && (
                      <Grid
                        item
                        xs={2}
                        sx={{ display: "flex", alignItems: "center" }}>
                        <IconButton onClick={() => arrayHelpers.remove(index)}>
                          <Delete />
                        </IconButton>
                      </Grid>
                    )}
                  </Grid>
                ))}
            </div>
          )}
        />
      </Box>

      <Box sx={{ px: 3, py: 1 }}>
        <CallFlowPlanDetail
          formik={formik}
          rootKey={`${formKey}.detailPlan`}
          title="Kịch bản cuộc gọi"
          mode={mode}
        />
      </Box>
    </Box>
  );
};

export default CallFlowSetupPlan;
